import PropTypes from 'prop-types'
import { createContext, useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { getCurrentUser } from './api/auth'

export const AuthContext = createContext({ user: undefined })

const AuthProvider = ({ children }) => {
  const Router = useRouter()

  const [user, setUser] = useState(undefined)

  const updateCurrentUser = (currentUser) => {
    setUser(currentUser)
  }

  useEffect(() => {
    const loadUser = async () => {
      const { data, error } = await getCurrentUser()
      if (data) {
        setUser(data)
      }

      if (error) {
        Router.replace('/login')
      }
    }

    if (!user) {
      loadUser()
    }
  }, [user])

  return (
    <AuthContext.Provider value={{ user, updateCurrentUser }}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.element,
}

export default AuthProvider
